const nserial2 = '090123456789'
const nserial3 = '0890123456789789 019'
const nserial4 = '07890123456789'
const logarithm = ['05', '16', '27', '38', '49', '50', '61', '72', '83', '94']

const posMapping = {
  '前': '万',
  '中': '百',
  '后': '个',
  '前二': '万千',
  '后二': '十个',
  '前三': '万千百',
  '中三': '千百十',
  '后三': '百十个',
  '前四': '万千百十',
  '后四': '千百十个',
  '1位': '万',
  '2位': '千',
  '3位': '百',
  '4位': '十',
  '5位': '个',
  '12位': '万千',
  '13位': '万百',
  '14位': '万十',
  '15位': '万个',
  '23位': '千百',
  '24位': '千十',
  '25位': '千个',
  '34位': '百十',
  '35位': '百个',
  '45位': '十个',
  '123位': '万千百',
  '124位': '万千十',
  '125位': '万千个',
  '134位': '万百十',
  '135位': '万百个',
  '145位': '万十个',
  '234位': '千百十',
  '235位': '千百个',
  '245位': '千十个',
  '345位': '百十个',
  '1234位': '万千百十',
  '1345位': '万百十个',
  '1245位': '万千十个',
  '1235位': '万千百个',
  '2345位': '千百十个',
}

const codePosMapping = {
  OXXXX: '万',
  XOXXX: '千',
  XXOXX: '百',
  XXXOX: '十',
  XXXXO: '个',
  OOXXX: '万千',
  OXOXX: '万百',
  OXXOX: '万十',
  OXXXO: '万个',
  XOOXX: '千百',
  XOXOX: '千十',
  XOXXO: '千个',
  XXOOX: '百十',
  XXOXO: '百个',
  XXXOO: '十个',
  OOOXX: '万千百',
  OOXOX: '万千十',
  OOXXO: '万千个',
  OXOOX: '万百十',
  OXOXO: '万百个',
  OXXOO: '万十个',
  XOOOX: '千百十',
  XOOXO: '千百个',
  XOXOO: '千十个',
  XXOOO: '百十个',
  OOOOX: '万千百十',
  OXOOO: '万百十个',
  OOXOO: '万千十个',
  OOOXO: '万千百个',
  XOOOO: '千百十个',
}
const posCodeMapping = Object.fromEntries(Object.entries(codePosMapping).map(([k, v]) => [v, k]))

export function parse(cmd, defaultMethod = '') {
  const positions = []
  const numbers = []
  const options = []
  let amount = NaN

  let buf = []
  let prev = ''
  let flexible = true
  let amountSeparator = false
  let singles = true
  const errors = []

  for (let i = 0; i < cmd.length; i++) {
    const c = cmd[i]
    switch (c) {
      case '万':
      case '千':
      case '百':
      case '十':
      case '个':
        if (prev === 'o' && buf.length) {
          options.push(buf.join(''))
          buf = []
        } else if (prev === 'n' && buf.length) {
          numbers.push(buf.join(''))
          buf = []
        }
      case '前':
      case '中':
      case '后':
        if (prev !== 'p') { prev = 'p' }
        buf.push(c)
        break
      case '位':
        if (prev === 'n' && buf.length) {
          positions.push(...(posMapping[`${buf.join('')}${c}`] ?? ''))
          buf = []
        }
        break
      case '二':
      case '三':
      case '四':
        if (prev === 'o') {
          buf.push(c)
        } else if (prev === 'p' && buf.length) {
          positions.push(...buf, c)
          buf = []
        }
        break
      case '全':
        if (prev === 'p' && buf.length) {
          positions.push(...buf)
          buf = []
        }
        if (cmd.at(i + 1) === '转') {
          if (prev !== 'o') { prev = 'o' }
          buf.push(c)
          break
        }
        if (prev !== 'n') { prev = 'n' }
        numbers.push('0123456789')
        break
      case '单':
        if (prev === 'p' && buf.length) {
          positions.push(...buf)
          buf = []
        }
        if (prev !== 'n') { prev = 'n' }
        numbers.push('13579')
        break
      case '双':
        if (prev === 'o') {
          buf.push(c)
          break
        }
        if (prev === 'p' && buf.length) {
          positions.push(...buf)
          buf = []
        }
        if (prev !== 'n') { prev = 'n' }
        numbers.push('02468')
        break
      case '大':
        if (prev === 'p' && buf.length) {
          positions.push(...buf)
          buf = []
        }
        if (prev !== 'n') { prev = 'n' }
        numbers.push('56789')
        break
      case '小':
        if (prev === 'p' && buf.length) {
          positions.push(...buf)
          buf = []
        }
        if (prev !== 'n') { prev = 'n' }
        numbers.push('01234')
        break
      case '0':
      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
      case '6':
      case '7':
      case '8':
      case '9':
        if (prev === 'o') {
          buf.push(c)
          break
        } else if (prev === 'p' && buf.length) {
          positions.push(...buf)
          buf = []
        }
        if (prev !== 'n') { prev = 'n' }
        buf.push(c)
        break
      case '.':
        buf.push(c)
        break
      case ' ':
        if (prev === 'p' && buf.length) {
          positions.push(...buf)
          flexible = false
          buf = []
        } else if (prev === 'n' && buf.length) {
          numbers.push(buf.join(''))
          flexible = false
          buf = []
        }
        break
      case '/':
        amountSeparator = true
      case '-':
        if (prev === 'o' && buf.length) {
          options.push(buf.join(''))
          buf = []
        } else if (prev === 'n' && buf.length) {
          numbers.push(buf.join(''))
          buf = []
        }
        break
      case '各':
        singles = false
      case '=':
        amountSeparator = true
        if (prev === 'o' && buf.length) {
          options.push(buf.join(''))
          buf = []
        } else if (prev === 'p' && buf.length) {
          positions.push(...buf)
          buf = []
        } else if (prev === 'n' && buf.length) {
          numbers.push(buf.join(''))
          buf = []
        }
        break
      case '去':
        if (prev === 'o' && buf.length) {
          options.push(buf.join(''))
          buf = []
        } else if (prev === 'p' && buf.length) {
          positions.push(...buf)
          buf = []
        } else if (prev === 'n' && buf.length) {
          numbers.push(buf.join(''))
          buf = []
        }
        if (prev !== 'o') { prev = 'o' }
        buf.push(c)
        break
      case '对':
      case '数':
        buf.push(c)
        break
      case '重':
      case '兄':
        if (prev === 'o') {
          options.push([...buf, c].join(''))
          buf = []
        }
        break
      case '取':
        if (prev === 'n' && buf.length) {
          numbers.push(buf.join(''))
          buf = []
        } else if (prev === 'o' && buf.length) {
          options.push(buf.join(''))
          buf = []
        }
      case '合':
        if (prev === 'o' && buf.length && !Number.isNaN(Number(buf.at(-1)))) {
          options.push(buf.join(''))
          buf = []
        }
        if (prev === 'n' && buf.length) {
          numbers.push(buf.join(''))
          buf = []
        }
      case '转':
        if (prev !== 'o') { prev = 'o' }
        buf.push(c)
        break
    default:
        errors.push(c)
    }
  }
  if (errors.length) {
    return { error: `指令"${cmd}"包含错误字符"${errors.join('')}"` }
  }
  if (buf.length && amountSeparator) {
    amount = Number(buf.join(''))
  }
  if (Number.isNaN(amount)) {
    return { error: `指令"${cmd}"没有金额` }
  }
  if (amount <= 0) {
    return { error: `指令"${cmd}"金额不正确` }
  }

  let method = positions.length ? positions.join('') : defaultMethod
  method = posCodeMapping[posMapping[method] ?? method] ?? method
  for (let i = 0; i < method.length; i++) {
    if (method[i] !== 'O' && method[i] !== 'X') {
      return { error: `指令"${cmd}"不正确` }
    }
  }

  for (let i = 0; i < options.length; i++) {
    const o = options[i]
    if (['去重', '去双双重', '去三重', '去四重', '去二兄', '去三兄', '去四兄'].indexOf(o) > -1) {
    } else if (o.startsWith('合')) {
      if (Number.isNaN(Number(o.slice(1)))) {
        return { error: `指令"${cmd}"选项"${o.slice(0, 1)}"参数不正确` }
      }
    } else if (o.startsWith('取二合') || o.startsWith('取三合')) {
      if (Number.isNaN(Number(o.slice(3)))) {
        return { error: `指令"${cmd}"选项"${o.slice(0, 3)}"参数不正确` }
      }
    } else if (options[i].startsWith('全转')) {
      numbers.push(options[i].slice(2))
      options[i] = '去重'
    } else if (options[i].startsWith('去对数')) {
      const n = o.slice(3)
      if (n.length > 6 || Number.isNaN(Number(n))) {
        return { error: `指令"${cmd}"去对数参数不正确` }
      }
    } else {
      return { error: `指令"${cmd}"选项"${o}"不正确` }
    }
  }

  const n = method.match(/O/g).length
  if (n !== numbers.length) {
    if (numbers.length !== 1 && flexible) {
      return { error: `指令"${cmd}"的数字组合长度不正确` }
    }
    if (!singles || n !== numbers[0].length) {
      while (numbers.length < n) {
        numbers.push(numbers.at(0))
      }
    }
  }
  if (!flexible) {
    for (let i = 0; i < numbers.length; i++) {
      if (numbers[i].length !== n) {
        return { error: `指令"${cmd}"的数字组合长度不正确` }
      }
    }
  }
  for (let i = 0; i < options.length; i++) {
    const m = options[i].match(/合(\d+)?/)
    if (m && m[1] === undefined) {
      return { error: `指令"${cmd}"合的参数不正确` }
    }
  }

  return { method, numbers: numbers.map(e => [...new Set(e)].join('')), amount, flexible, options }
}

export function output(parsed) {
  const numbers = []
  const n = parsed.method.match(/O/g).length

  if (!parsed.flexible) {
    for (const arr of parsed.numbers) {
      if (n === 3) {
        numbers.push(arr)
      }
      if (n === 2) {
        let num = parsed.method
        numbers.push(num.replace('O', arr[0]).replace('O', arr[1]))
      }
    }
    return numbers
  }

  const onlySum = parsed.options.find(e => e.startsWith('合'))

  if (n === 1) {
    const arr = parsed.numbers[0]
    const sum = onlySum ? onlySum.slice(1).split('').map(e => Number(e)) : false
    for (let a = 0; a < arr.length; a++) {
      if (sum) {
        const n1 = Number(arr[a])
        let found = false
        for (let i = 0; i < sum.length; i++) {
          if (sum[i] === n1) {
            found = true
            break
          }
        }
        if (!found) continue
      }
      let num = parsed.method
      numbers.push(num.replace('O', arr[a]))
    }
    return numbers
  }

  const removeDuplicates = parsed.options.indexOf('去重') > -1
  const removeBrothers = parsed.options.indexOf('去二兄') > -1
  const removeLogarithm = parsed.options.find(e => e.startsWith('去对数'))
  const onlySum2 = parsed.options.find(e => e.startsWith('取二合'))

  if (n === 2) {
    const arr1 = parsed.numbers[0]
    if (parsed.numbers.length === 1) {
      let num = parsed.method
      numbers.push(num.replace('O', arr1[0]).replace('O', arr1[1]))
      return numbers
    }
    const arr2 = parsed.numbers[1]
    const sum = onlySum ? onlySum.slice(1).split('').map(e => Number(e)) : false
    const sum2 = onlySum2 ? onlySum2.slice(3).split('').map(e => Number(e)) : false
    for (let a = 0; a < arr1.length; a++) {
      for (let b = 0; b < arr2.length; b++) {
        const n1 = arr1[a], n2 = arr2[b]
        if (removeDuplicates && n1 === n2) {
          continue
        }
        if (removeBrothers) {
          const r = [n1, n2]
          r.sort()
          if (nserial2.indexOf(`${r[0]}${r[1]}`) > -1) {
            continue
          }
        }
        if (removeLogarithm) {
          const r = [n1, n2]
          r.sort()
          if (logarithm.indexOf(`${r[0]}${r[1]}`) > -1) {
            const nums = removeLogarithm.slice(3)
            if (!nums) {
              continue
            }
            if (
              nums.indexOf(n1) > -1
              || nums.indexOf(n2) > -1
            ) {
              continue
            }
          }
        }
        if (sum) {
          const r = (Number(n1) + Number(n2)) % 10
          let found = false
          for (let i = 0; i < sum.length; i++) {
            if (sum[i] === r) {
              found = true
              break
            }
          }
          if (!found) continue
        }
        if (sum2) {
          const r = (Number(n1) + Number(n2)) % 10
          let found = false
          for (let i = 0; i < sum2.length; i++) {
            if (sum2[i] === r) {
              found = true
              break
            }
          }
          if (!found) continue
        }
        let num = parsed.method
        numbers.push(num.replace('O', arr1[a]).replace('O', arr2[b]))
      }
    }
    return numbers
  }

  const removeDuplicates3 = parsed.options.indexOf('去三重') > -1
  const removeBrothers3 = parsed.options.indexOf('去三兄') > -1
  const onlySum3 = parsed.options.find(e => e.startsWith('取三合'))

  if (n === 3) {
    const arr1 = parsed.numbers[0]
    if (parsed.numbers.length === 1) {
      let num = parsed.method
      numbers.push(num.replace('O', arr1[0]).replace('O', arr1[1]).replace('O', arr1[2]))
      return numbers
    }
    const arr2 = parsed.numbers[1], arr3 = parsed.numbers[2]
    const sum = onlySum ? onlySum.slice(1).split('').map(e => Number(e)) : false
    const sum2 = onlySum2 ? onlySum2.slice(3).split('').map(e => Number(e)) : false
    const sum3 = onlySum3 ? onlySum3.slice(3).split('').map(e => Number(e)) : false
    for (let a = 0; a < arr1.length; a++) {
      for (let b = 0; b < arr2.length; b++) {
        for (let c = 0; c < arr3.length; c++) {
          const n1 = arr1[a], n2 = arr2[b], n3 = arr3[c]
          if (removeDuplicates && (n1 === n2 || n1 === n3 || n2 === n3)) {
            continue
          }
          if (removeDuplicates3 && n1 === n2 && n1 === n3) {
            continue
          }
          if (removeBrothers) {
            const r = [n1, n2, n3]
            r.sort()
            r.push(r[0])
            if (
              nserial2.indexOf(`${r[0]}${r[1]}`) > -1
              || nserial2.indexOf(`${r[1]}${r[2]}`) > -1
              || nserial2.indexOf(`${r[2]}${r[3]}`) > -1
            ) {
              continue
            }
          }
          if (removeBrothers3) {
            const r = [n1, n2, n3]
            r.sort()
            r.push(r[0], r[1])
            if (
              nserial3.indexOf(`${r[0]}${r[1]}${r[2]}`) > -1
              || nserial3.indexOf(`${r[1]}${r[2]}${r[3]}`) > -1
              || nserial3.indexOf(`${r[2]}${r[3]}${r[4]}`) > -1
            ) {
              continue
            }
          }
          if (removeLogarithm) {
            const r = [n1, n2, n3]
            r.sort()
            if (([
              `${r[0]}${r[1]}`, `${r[0]}${r[2]}`,
              `${r[1]}${r[2]}`
            ]).some(e => logarithm.indexOf(e) > -1)) {
              const nums = removeLogarithm.slice(3)
              if (!nums) {
                continue
              }
              if (
                nums.indexOf(n1) > -1
                || nums.indexOf(n2) > -1
                || nums.indexOf(n3) > -1
              ) {
                continue
              }
            }
          }
          if (sum) {
            const r = (Number(n1) + Number(n2) + Number(n3)) % 10
            let found = false
            for (let i = 0; i < sum.length; i++) {
              if (sum[i] === r) {
                found = true
                break
              }
            }
            if (!found) { continue }
          }
          if (sum2) {
            const r = [
              (Number(n1) + Number(n2)) % 10,
              (Number(n1) + Number(n3)) % 10,
              (Number(n2) + Number(n3)) % 10
            ]
            let found = false
            for (let i = 0; i < sum2.length; i++) {
              for (let j = 0; j < r.length; j++) {
                if (sum2[i] === r[j]) {
                  found = true
                  break
                }
              }
              if (found) { break }
            }
            if (!found) { continue }
          }
          if (sum3) {
            const r = (Number(n1) + Number(n2) + Number(n3)) % 10
            let found = false
            for (let i = 0; i < sum3.length; i++) {
              if (sum3[i] === r) {
                found = true
                break
              }
            }
            if (!found) { continue }
          }
          let num = parsed.method
          numbers.push(num.replace('O', arr1[a]).replace('O', arr2[b]).replace('O', arr3[c]))
        }
      }
    }
    return numbers
  }

  const removeDuplicates4 = parsed.options.indexOf('去四重') > -1
  const remove2x2Duplicates = parsed.options.indexOf('去双双重') > -1
  const removeBrothers4 = parsed.options.indexOf('去四兄') > -1

  if (n === 4) {
    const arr1 = parsed.numbers[0]
    if (parsed.numbers.length === 1) {
      let num = parsed.method
      numbers.push(num.replace('O', arr1[0]).replace('O', arr1[1]).replace('O', arr1[2]).replace('O', arr1[3]))
      return numbers
    }
    const arr2 = parsed.numbers[1], arr3 = parsed.numbers[2], arr4 = parsed.numbers[3]
    const sum = onlySum ? onlySum.slice(1).split('').map(e => Number(e)) : false
    const sum2 = onlySum2 ? onlySum2.slice(3).split('').map(e => Number(e)) : false
    const sum3 = onlySum3 ? onlySum3.slice(3).split('').map(e => Number(e)) : false
    for (let a = 0; a < arr1.length; a++) {
      for (let b = 0; b < arr2.length; b++) {
        for (let c = 0; c < arr3.length; c++) {
          for (let d = 0; d < arr4.length; d++) {
            const n1 = arr1[a], n2 = arr2[b], n3 = arr3[c], n4 = arr4[d]
            if (removeDuplicates && (n1 === n2 || n1 === n3 || n1 === n4 || n2 === n3 || n2 === n4 || n3 === n4)) {
              continue
            }
            if (removeDuplicates3 && ((n1 === n2 && n1 === n3) || (n1 === n2 && n1 === n4) || (n1 === n3 && n1 === n4) || (n2 === n3 && n1 === n4))) {
              continue
            }
            if (removeDuplicates4 && n1 === n2 && n1 === n3 && n1 === n4) {
              continue
            }
            if (remove2x2Duplicates && n1 === n2 && n2 === n3) {
              continue
            }
            if (removeBrothers) {
              const r = [n1, n2, n3, n4]
              r.sort()
              r.push(r[0])
              if (
                nserial2.indexOf(`${r[0]}${r[1]}`) > -1
                || nserial2.indexOf(`${r[1]}${r[2]}`) > -1
                || nserial2.indexOf(`${r[2]}${r[3]}`) > -1
                || nserial2.indexOf(`${r[3]}${r[4]}`) > -1
              ) {
                continue
              }
            }
            if (removeBrothers3) {
              const r = [n1, n2, n3, n4]
              r.sort()
              r.push(r[0], r[1])
              if (
                nserial3.indexOf(`${r[0]}${r[1]}${r[2]}`) > -1
                || nserial3.indexOf(`${r[1]}${r[2]}${r[3]}`) > -1
                || nserial3.indexOf(`${r[2]}${r[3]}${r[4]}`) > -1
                || nserial3.indexOf(`${r[3]}${r[4]}${r[5]}`) > -1
                || nserial3.indexOf(`${r[0]}${r[2]}${r[3]}`) > -1
              ) {
                continue
              }
            }
            if (removeBrothers4) {
              const r = [n1, n2, n3, n4]
              r.sort()
              r.push(r[0], r[1], r[2])
              if (
                nserial4.indexOf(`${r[0]}${r[1]}${r[2]}${r[3]}`) > -1
                || nserial4.indexOf(`${r[1]}${r[2]}${r[3]}${r[4]}`) > -1
                || nserial4.indexOf(`${r[2]}${r[3]}${r[4]}${r[5]}`) > -1
                || nserial4.indexOf(`${r[3]}${r[4]}${r[5]}${r[6]}`) > -1
              ) {
                continue
              }
            }
            if (removeLogarithm) {
              const r = [n1, n2, n3, n4]
              r.sort()
              if (([
                `${r[0]}${r[1]}`, `${r[0]}${r[2]}`, `${r[0]}${r[3]}`,
                `${r[1]}${r[2]}`, `${r[1]}${r[3]}`,
                `${r[2]}${r[3]}`,
              ]).some(e => logarithm.indexOf(e) > -1)) {
                const nums = removeLogarithm.slice(3)
                if (!nums) {
                  continue
                }
                if (
                  nums.indexOf(n1) > -1
                  || nums.indexOf(n2) > -1
                  || nums.indexOf(n3) > -1
                  || nums.indexOf(n4) > -1
                ) {
                  continue
                }
              }
            }
            if (sum) {
              const r = (Number(n1) + Number(n2) + Number(n3) + Number(n4)) % 10
              let found = false
              for (let i = 0; i < sum.length; i++) {
                if (sum[i] === r) {
                  found = true
                  break
                }
              }
              if (!found) { continue }
            }
            if (sum2) {
              const r = [
                (Number(n1) + Number(n2)) % 10,
                (Number(n1) + Number(n3)) % 10,
                (Number(n1) + Number(n4)) % 10,
                (Number(n2) + Number(n3)) % 10,
                (Number(n2) + Number(n4)) % 10,
                (Number(n3) + Number(n4)) % 10,
              ]
              let found = false
              for (let i = 0; i < sum2.length; i++) {
                for (let j = 0; j < r.length; j++) {
                  if (sum2[i] === r[j]) {
                    found = true
                    break
                  }
                }
                if (found) { break }
              }
              if (!found) { continue }
            }
            if (sum3) {
              const r = [
                (Number(n1) + Number(n2) + Number(n3)) % 10,
                (Number(n1) + Number(n2) + Number(n4)) % 10,
                (Number(n1) + Number(n3) + Number(n4)) % 10,
                (Number(n2) + Number(n3) + Number(n4)) % 10,
              ]
              let found = false
              for (let i = 0; i < sum3.length; i++) {
                for (let j = 0; j < r.length; j++) {
                  if (sum3[i] === r[j]) {
                    found = true
                    break
                  }
                }
                if (found) { break }
              }
              if (!found) { continue }
            }
            let num = parsed.method
            numbers.push(num.replace('O', arr1[a]).replace('O', arr2[b]).replace('O', arr3[c]).replace('O', arr4[d]))
          }
        }
      }
    }
    return numbers
  }

  return numbers
}
